import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  "everyDay",
  "fewTimesWeek",
  "occasionally",
  "rarelyOrNever",
] as const

export default function WhatsAppUsage() {
  return <SingleSelectPage translationKey="whatsAppUsage" options={OPTIONS} />
}
